import React from 'react'
import { tokens } from 'styling/tokens'
import { HonestTable, IHonestTableColumn } from 'components/HonestTable/HonestTable'
import { RateCell, RateBar, RateValue } from '../HrAnalytics.styled'

export interface ColumnDef {
  key: string
  label: string
  sortable?: boolean
  width?: string
  align?: 'start' | 'center' | 'end'
  renderCell?: (value: any, row: any) => React.ReactNode
}

interface IAnalyticsTable {
  columns: ColumnDef[]
  data: any[]
  minWidth?: string
  emptyText?: string
}

const getRateColor = (value: number): string => {
  if (value >= 90) return tokens.status.success.fg
  if (value >= 70) return tokens.accent.base
  return tokens.status.danger.fg
}

export const RateCellRenderer = ({ value }: { value: number }) => {
  const safe = Number(value) || 0
  const isEmpty = safe <= 0
  const color = isEmpty ? tokens.text.muted : getRateColor(safe)
  return (
    <RateCell>
      <RateBar percent={safe} color={color} />
      <RateValue color={color}>{safe}%</RateValue>
    </RateCell>
  )
}

export const RedValueRenderer = ({ value }: { value: number | string }) => {
  const display = value === null || value === undefined ? 0 : value
  return <span style={{ color: tokens.status.danger.fg, fontWeight: 600 }}>{display}</span>
}

const renderCellValue = (value: unknown): React.ReactNode => {
  if (value === null || value === undefined || value === '') return 0
  return value as React.ReactNode
}

export const AnalyticsTable = ({ columns, data, emptyText }: IAnalyticsTable) => {
  const rows = (data || []).map((row, i) => ({ ...row, id: row?.id ?? i }))
  const honestColumns: IHonestTableColumn<any>[] = columns.map((col) => ({
    id: col.key,
    header: col.label,
    minWidth: col.width,
    align: (col.align === 'center' ? 'center' : col.align === 'end' ? 'right' : 'left') as
      | 'left'
      | 'center'
      | 'right',
    cell: (row: any) =>
      col.renderCell ? col.renderCell(row[col.key], row) : renderCellValue(row[col.key]),
  }))

  return <HonestTable columns={honestColumns} data={rows} keyField='id' emptyMessage={emptyText} />
}
